import { useDeviceType } from '@cian/ui-kit';
import { UTP } from './constants';
import * as styles from './styles.css';
import { clsx } from 'clsx';

export const Utp: React.FC = () => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['title']}>Циан Посуточно — это сервис онлайн-бронирования</div>
      <div className={styles['utp']}>
        {UTP.map(({ image, title, description }, index) => (
          <div key={index} className={styles['item']}>
            <div className={clsx(styles['image'], styles[image])} />
            <div className={styles['item-title']}>{title}</div>
            <div className={styles['item-description']}>{description}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
